import React from "react";
import { Router } from "../Router";

interface IProps {}

export const Root: React.FC<IProps> = (props: IProps): React.ReactElement => {
  return <Router />;
};